import React, { Component } from "react";

import Vimeo from "@u-wave/react-vimeo";

export default class VideoLanding extends Component {
  render() {
    return (
      <div>
        <div className="auto" id = "video">
          <Vimeo
            className="videoWrapper"
            video="161243136"
            autoplay
            loop
            background
          >
  
          </Vimeo>
          <div className="captionBox">
            <div className="slidecaption" >
              Make your <span className="color-text">splash</span> with creative{" "}
              <span className="color-text">mobile</span> solutions
              <div className="sub-caption">Experience the difference</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
